import React, {Component} from 'react'
import PropTypes from "prop-types"
import getHistory from "../../../getHistory"

class SkuActions extends Component {
    _handleCancel = () => {
        const history = getHistory()
        history.push(`/sku-manager`)
    }

    render() {
        const {loading, actionUpdate, changeList, validateName, validateTime, commitmentTime, validatePartner, validateTimeFast, embroideryPosition, isEmbroidery} = this.props
        const validateEmbroideryPosition = isEmbroidery && !!embroideryPosition[0] && !embroideryPosition[0].side
        const disableBtn = loading || changeList.length === 0 || validateName !== '' || validateTime !== '' || !commitmentTime === null || commitmentTime === '' || validatePartner !== '' || validateTimeFast !== '' || validateEmbroideryPosition

        return (
            <div className="SkuActions d-flex align-items-center justify-content-between">
                <button disabled={loading} onClick={this._handleCancel} className="btn btn-secondary"
                        color="secondary">Hủy
                </button>
                <button
                    disabled={disableBtn}
                    onClick={actionUpdate}
                    className="btn btn-primary">
                    {loading && <i className="icon-spinner2 spinner mr-1"/>}
                    Cập nhật
                </button>
            </div>
        )
    }
}

SkuActions.propTypes = {
    actionUpdate: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    changeList: PropTypes.array.isRequired,
    validateName: PropTypes.string
}

export default SkuActions
